module.exports = __webpack_public_path__ + "static/img/weixin.54a1159e.svg";